(() => {
  const initReveal = () => {
    const items = document.querySelectorAll('.logenok-reveal');

    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
  };

  const initDrawer = () => {
    const drawer = document.querySelector('[data-logenok-drawer]');
    const openers = document.querySelectorAll('[data-logenok-drawer-open]');
    const closers = document.querySelectorAll('[data-logenok-drawer-close]');

    if (!drawer || !openers.length) return;

    let previousFocus = null;

    const openDrawer = () => {
      previousFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const closeButton = drawer.querySelector('[data-logenok-drawer-close]');
      if (closeButton) closeButton.focus();
    };

    const closeDrawer = () => {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    openers.forEach((opener) => opener.addEventListener('click', openDrawer));
    closers.forEach((closer) => closer.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  };

  const init = () => {
    initReveal();
    initDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
